import React, { Component } from "react"
import TimaticWidget from "../timatic-widget/timatic-widget-component"

export default class TimaticWidgetContainer extends Component {
  render() {
    return (
      <div className="widget-block-covid">
        <div className="grid">
          <div className="widget-block-covid__left grid-item col--12 col-sm--6">
            <div className="inner">
              <div className="widget-block-covid__header" dangerouslySetInnerHTML={{ __html: this.props.headline }}></div>
              <div className="widget-block-covid__info" dangerouslySetInnerHTML={{ __html: this.props.text }}></div>
              <div className="widget-block-covid__info__extra" dangerouslySetInnerHTML={{ __html: this.props.legalText }}></div>
            </div>
          </div>
          {this.props.widgetBlock && this.props.widgetBlock.length > 0 ? (
            <div className="widget-block-covid__right grid-item col--12 col-sm--6">
              <div className="inner">
                <TimaticWidget />
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    )
  }
}
